<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import { urlMethods } from "@/state/helpers";
import Swal from "sweetalert2";
export default {
  components: {},
  data: function() {
    return {
      transportFeeText: "",
      isLoading: false,
    };
  },
  computed: {
    currentUser: function() {
      return this.$store.getters["auth/currentUser"];
    },
    currentTab: function() {
      return this.$store.getters["sale/currentTab"];
    }
  },
  methods: {
    ...urlMethods,
    addTransportFee: async function(e) {
      let that = this;
      e.preventDefault();
      this.isLoading = true;
      this.$bvModal.hide("modal-transport-fee");
      this.$store.dispatch("sale/setTransportFee", this.transportFeeText);
      this.$store.dispatch("sale/recalcData");
      this.isLoading = false;
      return false;
    },
    closePopup() {
      this.$bvModal.hide("modal-transport-fee");
    },
  },
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "modal-transport-fee") {
        setTimeout(() => {
          this.isLoading = false;
          if (typeof this.$refs.transportFeeText != "undefined")
            this.$refs.transportFeeText.focus();
        }, 100);
      }
    });
  },
};
</script>

<template>
  <div>
    <b-modal
      id="modal-transport-fee"
      title="Phí vận chuyển"
      title-class="font-18"
      hide-footer
    >
      <form class="form-horizontal" role="form" @submit="addTransportFee">
        <b-form-group
          class="mb-5"
          label-cols-lg="5"
          label="Nhập phí vận chuyển"
          label-for="transportFeeText"
          ><b-form-input
            type="number"
            ref="transportFeeText"
            :disabled="isLoading"
            autocomplete="off"
            for="transportFeeText"
            v-model="transportFeeText"
          ></b-form-input
        ></b-form-group>
        <div class="text-right">
          <b-button type="submit" variant="primary" :disabled="isLoading"
            ><i class="bx bx-check"></i> Xác nhận</b-button
          >
        </div>
      </form>
    </b-modal>
  </div>
</template>
